<svg width="24" height="24" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(0,-290.65)" display="none">
  <path d="m11.892 294.65a8 8 89.237 0 0-7.8926 8.1074 8 8 89.237 0 0 8.1074 7.8926 8 8 89.237 0 0 7.8926-8.1074 8 8 89.237 0 0-8.1074-7.8926zm0.10742 1a7 7 0 0 1 7 7 7 7 0 0 1-7 7 7 7 0 0 1-7-7 7 7 0 0 1 7-7z"/>
  <path transform="translate(0,290.65)" d="m7 4.0195v0.98047h-2v2h-0.95703v10h0.95703v2h2v1h10v-1h2v-2h1v-10h-1v-2h-2v-0.98047z" fill-opacity=".27451" opacity=".544"/>
  <rect x="-6" y="284.65" width="36" height="36" fill="none" stroke="#000" stroke-width=".05"/>
  <circle cx="12" cy="302.65" r="18" fill="none" stroke="#000" stroke-width=".05"/>
 </g>
 <g>
  <g id="Notifications" transform="matrix(1 0 0 .94118 5 3.9)" fill-rule="evenodd">
   <g id="RTE_parts_temp" transform="translate(-1289,-3150)" style="">
    <g id="RTE_attach" transform="translate(53,2912)" style="">
     <g transform="translate(684,66)" style="">
      <g transform="translate(0,36)" style="">
       <g id="Materials_card" transform="translate(55,108)" style="">
        <g id="icon/close/24-24/file/download" style="">
         <g transform="translate(492,24)" style="">
          <path id="icon" d="m19 10h-4v-6h-6v6h-4l7 7zm-14 9v2h14v-2z" style=""/>
         </g>
        </g>
       </g>
      </g>
     </g>
    </g>
   </g>
  </g>
 </g>
</svg>
